import { Injectable } from '@angular/core';
import { DataCoreService, DlistDto, GetDlist_Request, GetDlist_Response} from '@dabnet-kamu/libs/ui';
import { BehaviorSubject, catchError, finalize, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@dabnet-kamu/libs/ui';
@Injectable()
export class TemImzaYetkiService {
  public period!: number;
  public institutionalCode!: string;
  public titleType!: number;
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
    public gridControlsList$ = this._gridControlsList.asObservable();
     constructor(private dataCoreService: DataCoreService,private _httpClient:HttpClient) {}


  setParams(period: number, institutionalCode: string, titleType: number,isReadOnly:boolean, isBindCheck:boolean){
    this.period = period;
    this.institutionalCode = institutionalCode;
    this.titleType = titleType;
    this.isReadOnly = isReadOnly;
    this.isBindCheck = isBindCheck;
  }

  // DKM-5331 Cedric (18.10): İSTEĞE BAĞLI aktiflik süzgeci — yalnız ekran [aktifEh] / [aktifTarih] verirse dolar.
  // Varsayılan null: setParams ve istekler eskisiyle birebir aynı (68 kullanımın 66'sı bu girişleri vermez).
  public aktifEh: string | null = null;
  public aktifTarih: Date | string | number | null = null;

  setAktiflik(aktifEh: string | null, aktifTarih: Date | string | number | null) {
    this.aktifEh = aktifEh || null;
    this.aktifTarih = aktifTarih ?? null;
  }

  /**
   * DKM-5331 Cedric (18.10): [aktifEh] → AKTIF_EH; [aktifTarih] → o gün görevde olanlar
   * (GOREV_BASLAMA_TARIH ≤ gün, GOREV_BITIS_TARIH boş ya da ≥ gün; gün bazında, yerel saat). Girişler boşsa boş dizi.
   * Servis tarafı aynı ölçütle reddeder (ör. TemHarcamaTalimatBs.GorevTarihiKontrol).
   */
  aktiflikFiltreleri(): any[] {
    const f: any[] = [];
    if (this.aktifEh) f.push(['AktifEh', '=', this.aktifEh]);
    const t = this.aktifTarih != null && this.aktifTarih !== '' ? new Date(this.aktifTarih) : null;
    if (t && !isNaN(t.getTime())) {
      const gun = new Date(t.getFullYear(), t.getMonth(), t.getDate());
      const ertesiGun = new Date(gun);
      ertesiGun.setDate(ertesiGun.getDate() + 1);
      f.push(['GorevBaslamaTarih', '<', ertesiGun]);
      f.push([['GorevBitisTarih', '=', null], 'or', ['GorevBitisTarih', '>=', gun]]);
    }
    return f;
  }

  getData(code: number,control:any, baseEntity?: string, isSetData?: boolean) {
     let dataSource: any;
     let tableName = "";
    const filterArr = [];
      if (this.isBindCheck && this.isReadOnly){
      tableName = control.showEntity?control.showEntity:control.dlistMetadata.baseEntity;
      dataSource = this.dataCoreService.getOData(tableName);
    dataSource.select([
      'Kod',
      'Ad',
      'Soyad',
      'KurumsalKod',
      'UnvanTuru',
      'Unvani',
      'Donem',
    ]);
    } 
    else{
      dataSource = this.dataCoreService.getOData(baseEntity);
    dataSource.select([
      'Kod',
      'Ad',
      'Soyad',
      'KurumsalKod',
      'UnvanTuru',
      'Unvani',
      'Donem',
    ]);
    if(this.period) filterArr.push(['Donem', '=', this.period]);
    if(this.institutionalCode) filterArr.push(['KurumsalKod', '=', this.institutionalCode]);
    if(this.titleType) filterArr.push(['UnvanTuru', '=', this.titleType]);
    // DKM-5331 Cedric (18.10): kod elle yazılınca (düzenleme) aktiflik süzgeci; kayıtlı kodun ilk okunuşu (isSetData) ve salt okunur
    // gösterim süzülmez — sonradan pasifleşen yetkilinin adı kaybolmasın, kod silinmesin (karar servis doğrulamasında).
    if (!isSetData && !this.isReadOnly) filterArr.push(...this.aktiflikFiltreleri());
    }
    if (code) filterArr.push(['Kod', '=', code]);
    if(filterArr.length > 0) dataSource.filter(filterArr)
    return dataSource;
  }
}
